<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgement</h1>
<p>I wish to also thank my friends in Stoicism, Karen Van den Broek, PhD and Kristian Van der Pals, PhD, for their valued input and support. I would also acknowledge the valuable theological and philosophical input provided by my colleague, Giorgio D’Arbe.</p>
<br/>
<p style="text-indent: 00em !important;">Not least to my loving wife, Yvonne, who endured numerous months without my company in completing this work.</p>
<br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2c9ef771